import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import ButtonOutline1 from '../components/button-outline1'
import Footer from '../components/footer'
import './over-mij-oud.css'

const OverMijOud = (props) => {
  return (
    <div className="over-mij-oud-container1">
      <Helmet>
        <title>Marjan Gerrits</title>
        <meta
          name="description"
          content="Marjan Gerrits heeft een dubbelroman geschreven over de Tweede Wereldoorlog."
        />
        <meta property="og:title" content="Marjan Gerrits" />
        <meta
          property="og:description"
          content="Marjan Gerrits heeft een dubbelroman geschreven over de Tweede Wereldoorlog."
        />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="over-mij-oud-top">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name1"></NavbarInteractive>
        <div className="over-mij-oud-container2">
          <h1>Over mij</h1>
          <span>Schrijversacademie en daarna</span>
        </div>
      </div>
      <div className="over-mij-oud-container3">
        <img
          alt="image"
          src="/mask%20group-300w.png"
          className="over-mij-oud-image1"
        />
        <div className="over-mij-oud-container4">
          <h2 className="over-mij-oud-text12">
            <span>Welkom op de site!</span>
            <br></br>
          </h2>
          <span>
            Ik ben Marjan Gerrits, in 1963 geboren in Zeist en via vele
            omzwervingen in het mooie Bakkum terecht gekomen. In mijn tuin heb
            ik een schuurtje uit 1910 omgetoverd tot een inspirerend
            schrijfhuisje. Hier werk ik aan mijn roman en aan andere vormen van
            woordkunst.
          </span>
        </div>
      </div>
      <div className="over-mij-oud-container5">
        <h3 className="over-mij-oud-text16">Schrijversacademie en daarna</h3>
        <span className="over-mij-oud-text17">
          <span>
            Na de basisopleiding van de Schrijversacademie heb ik met veel
            plezier de specialisatie Familieverhalen en biografieën gevolgd. Op
            7 september 2019 heb ik mijn getuigschrift ontvangen inclusief zeer
            positieve feedback op mijn eindopdracht. Daar was ik natuurlijk heel
            blij mee maar het echte werk begon toen pas. En wat een proces is
            dat.
          </span>
          <br></br>
          <br></br>
          <span>
            Het schrijven van een boek gebaseerd op de gebeurtenissen van mijn
            vader en schoonvader in de Tweede Wereldoorlog heeft mijn leven
            behoorlijk veranderd. Archiefonderzoek, het bezoeken van alle
            plekken die in het boek voorkomen, deskundigen interviewen, vertalen
            van honderden brieven vanuit het Sütterlin naar het Duits van nu.
          </span>
          <br></br>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
        </span>
      </div>
      <div className="over-mij-oud-container6">
        <img
          alt="image"
          src="/schrijfhuisje-800w.jpg"
          className="over-mij-oud-image2"
        />
        <span className="over-mij-oud-text25">
          <span>
            Het schuurtje uit 1910, omgetoverd tot inspirerend schrijfhuisje.
          </span>
          <br></br>
        </span>
      </div>
      <div className="over-mij-oud-container7">
        <h4 className="over-mij-oud-text28">
          {' '}
          Spitten, graven om net dat kleine beetje extra informatie boven tafel
          te krijgen.
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </h4>
        <span className="over-mij-oud-text29">
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span>
            {' '}
            En het dan ook nog eens prettig leesbaar opschrijven. Het is een
            hele toer maar ik zou het niet willen missen. De vreugde als je weer
            een stukje van de puzzel gevonden hebt, het plezier als je het
            juiste woord op de juiste plek hebt gezet of nieuwe informatie met
            mijn partner kan delen over haar vader.
          </span>
          <br></br>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <span>
            Natuurlijk zijn er ook tegenslagen. Soms lukt het niet de juiste
            informatie te vinden, ondanks uren onderzoek. Of de tekst loopt niet
            lekker en je kunt er de vinger niet op leggen. En niet in de laatste
            plaats de onzekerheid die je hebt als beginnend schrijver. Ik in
            ieder geval. Kan ik dit wel? Wie zit er op dit boek te wachten?
          </span>
          <br></br>
        </span>
        <h4 className="over-mij-oud-text37">
          {' '}
          Dan raap ik mijzelf bij elkaar en bedenk waarom ik dit boek zo graag
          wil schrijven.
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </h4>
        <span className="over-mij-oud-text38">
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span>
            Er zijn veel oorlogsboeken geschreven, maar hoeveel gaan over de
            gewone jongemannen die in die tijd opgroeiden? De jongemannen die
            probeerden zo goed mogelijk door de oorlog te komen, geen bijzondere
            helden. En toch worden ze in de oorlog meegesleurd. 
          </span>
          <span>
            En hoeveel boeken beschrijven zowel het leven van een Nederlander
            als een Duitser in oorlogstijd? Naar mijn mening veel te weinig.
          </span>
          <br></br>
          <br></br>
          <span className="over-mij-oud-text44">
            En dan weet ik weer waarom ik dit doe. 
          </span>
          <br></br>
          <br></br>
          <span>
            Het is soms zware kost en als tegenhanger maak ik graag
            &apos;woordkunst&apos;, soms om woorden aan mijn emoties te geven,
            meestal luchtige vrolijke teksten in de vorm van gedichten en
            haiku&apos;s. Spelen met tekst geeft mijn hoofd vrijheid. In een een
            later stadium komen deze ook op de site. 
          </span>
          <br></br>
          <br></br>
          <span className="Dikgedrukt_tekst">
            Wil je reageren of heb je een vraag? Feedback wordt altijd op prijs
            gesteld!
          </span>
          <br></br>
        </span>
        <a
          href="mailto:marjangerrits@gmail.com?subject=Schrijfvrijheid"
          className="over-mij-oud-link"
        >
          <ButtonOutline1
            text="Stuur een mailtje naar marjangerrits@gmail.com"
            imageAlt="Neem contact op"
            rootClassName="button-outline1root-class-name5"
            className="over-mij-oud-component2"
          ></ButtonOutline1>
        </a>
      </div>
      <Footer rootClassName="footerroot-class-name9"></Footer>
    </div>
  )
}

export default OverMijOud
